import { render, staticRenderFns } from "./FranckHertzViz.vue?vue&type=template&id=220377b2&scoped=true"
import script from "./FranckHertzViz.vue?vue&type=script&lang=js"
export * from "./FranckHertzViz.vue?vue&type=script&lang=js"
import style0 from "./FranckHertzViz.vue?vue&type=style&index=0&id=220377b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220377b2",
  null
  
)

export default component.exports